export default __webpack_public_path__ + "static/media/Brunch-hover.c94d643b.svg";